import { marthasVineyardConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function MarthasVineyardPage() {
  return <CityPageTemplate config={marthasVineyardConfig} />;
}